export const METABASE = 'https://closegap-metabase.herokuapp.com/question' as const

export const GOOGLE = 'https://www.google.com/search?q=' as const
